import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  isLogIn: false,
};

const SignInReducer = createSlice({
  name: "SignInReducer",
  initialState: initialState,
  reducers: {
    loginIn: (state) => {
      return {
        ...state,
        isLogIn: true,
      };
    },
    logOut: (state) => {
      return {
        ...state,
        isLogIn: false,
      };
    },
  },
});

export default SignInReducer;
